import React, { useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Button, Container } from 'reactstrap';
import history from '../../../history';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faPlus } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import 'moment-timezone';
import AlertModal from '../../../shared/components/Modal';
import ModalAffairComplaint from './ModalAffairComplaint';
import IconButton from '@material-ui/core/IconButton';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const FormComplaintsAndClaims = (props) => {

    //Formulario
    const [errors, setErrors] = useState({});
    const [disabledFields, setDisabledFields] = useState(false);
    const [openModalAffair, setOpenModalAffair] = useState(false);
    const [dataAffairs, setDataAffairs] = useState([]);

    //Datos del Paciente
    const [namePatient, setNamePatient] = useState(null);
    const [firstLastName, setFirstLastName] = useState(null);
    const [secondLastName, setSecondLastName] = useState(null);
    const [numberDocument, setNumberDocument] = useState(null);
    const [typeDocument, setTypeDocument] = useState(null);
    const [emailPatient, setEmailPatient] = useState(null);
    const [phonePatient, setPhonePatient] = useState(null);

    //Queja y/o Reclamo
    const [claimDate, setClaimDate] = useState(null);
    const [meanComplaint, setMeanComplaint] = useState(null);
    const [tracing, setTracing] = useState(1);
    const [receptionChanel, setReceptionChanel] = useState(null);
    const [priority, setPriority] = useState(2);
    const [subject, setSubject] = useState(null);
    const [textComplaint, setTextComplaint] = useState(null);

    //Respuesta
    const [answerDate, setAnswerDate] = useState(null);
    const [answerText, setAnswerText] = useState(null);

    //Alerta
    const [colorAlertModal, setColorAlertModal] = useState("");
    const [messageAlertModal, setMessageAlertModal] = useState("");
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [optionAlertModal, setOptionAlertModal] = useState(false);

    const [disabledAnswer, setDisabledAnswer] = useState(false);

    const toBack = () => {
        history.push({
            pathname: process.env.PUBLIC_URL + '/assitencial/complaints-claims',
            state: { complaints_claim: null }
        });
    }

    useEffect(() => {
        loadDataClaim();
        getAffairs();
    }, []);

    const loadDataClaim = () => {
        if (props.location.state.complaints_claim != null && props.location.state.complaints_claim != undefined) {

            //Datos del Paciente
            setNamePatient(props.location.state.complaints_claim.nombres);
            setFirstLastName(props.location.state.complaints_claim.apellido1);
            setSecondLastName(props.location.state.complaints_claim.apellido2);
            setNumberDocument(props.location.state.complaints_claim.num_documento);
            setTypeDocument(props.location.state.complaints_claim.tip_documento);
            setEmailPatient(props.location.state.complaints_claim.correo);
            setPhonePatient(props.location.state.complaints_claim.celular);

            //Queja y/o Reclamo
            let fecha_radicado = props.location.state.complaints_claim.fecha_radicado != null && props.location.state.complaints_claim.fecha_radicado != undefined ? moment(props.location.state.complaints_claim.fecha_radicado).toDate() : null;
            setClaimDate(fecha_radicado);
            setMeanComplaint(props.location.state.complaints_claim.medio);
            setTracing(props.location.state.complaints_claim.seguimiento);
            setReceptionChanel(props.location.state.complaints_claim.canal_recepcion);
            setPriority(props.location.state.complaints_claim.prioridad);
            setTextComplaint(props.location.state.complaints_claim.queja_reclamo);
            setSubject(props.location.state.complaints_claim.id_queja_asunto);

            //Respuesta
            let fecha_respuesta = props.location.state.complaints_claim.fecha_respuesta != null && props.location.state.complaints_claim.fecha_respuesta != undefined ? moment(props.location.state.complaints_claim.fecha_respuesta).toDate() : null;

            if (fecha_respuesta != null) {
                setAnswerDate(fecha_respuesta);
                setDisabledAnswer(true);
            }
            else
            {
                setAnswerDate(moment().tz("America/Bogota").toDate());
                setDisabledAnswer(false);
            }
  
            setAnswerText(props.location.state.complaints_claim.respuesta_requerimiento);
            setDisabledFields(true);
        }
        else {
            let fecha_actual = moment().tz("America/Bogota").toDate();
            setClaimDate(fecha_actual);
        }
    }

    const loadPatientInfo = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ num_documento: numberDocument })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(data => {
            console.log("patientInfo", data);
            if (data.existe) {
                setNamePatient(data.contenido[0].nombres);
                setFirstLastName(data.contenido[0].apellido1);
                setSecondLastName(data.contenido[0].apellido2);
                setNumberDocument(data.contenido[0].num_documento);
                setTypeDocument(data.contenido[0].tip_documento);
                setEmailPatient(data.contenido[0].correo);
                setPhonePatient(data.contenido[0].celular);

            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const addComplaintsAndClaimsSubmit = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'quejas-reclamos/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                nombres: namePatient != null && namePatient != undefined ? namePatient : null,
                apellido1: firstLastName != null && firstLastName != undefined ? firstLastName : null,
                apellido2: secondLastName != null && secondLastName != undefined ? secondLastName : null,
                num_documento: numberDocument,
                tip_documento: typeDocument,
                correo: emailPatient,
                telefono: phonePatient,
                fecha_radicado: claimDate != null && claimDate != null ? moment(claimDate).format("YYYY-MM-DD HH:mm:ss") : null,
                queja_reclamo: textComplaint,
                fecha_respuesta: null,
                respuesta_requerimiento: null,
                medio: meanComplaint,
                seguimiento: tracing,
                canal_recepcion: receptionChanel,
                id_usuario: JSON.parse(sessionStorage.getItem('usuario')).id_usuario,
                prioridad: priority,
                asunto: dataAffairs.find(dat => dat.id_queja_asunto == subject).queja_asunto,
                id_queja_asunto: subject
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                configAlertModal("success", "Queja Creada con Exito", 3, true);
            }
            else {
                throw new Error('Ha ocurrido un error creando la Queja');
            }
        }).catch(err => {
            configAlertModal("danger", "Ha ocurrido un error creando la Queja", null, true);
            console.log(err);
        });
    }

    const updateComplaintsAndClaimsSubmit = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'quejas-reclamos/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_queja: props.location.state.complaints_claim.id_queja,
                nombres: namePatient != null && namePatient != undefined ? namePatient : null,
                apellido1: firstLastName != null && firstLastName != undefined ? firstLastName : null,
                apellido2: secondLastName != null && secondLastName != undefined ? secondLastName : null,
                num_documento: numberDocument,
                tip_documento: typeDocument,
                correo: emailPatient,
                telefono: phonePatient,
                fecha_radicado: claimDate != null && claimDate != null ? moment(claimDate).format("YYYY-MM-DD HH:mm:ss") : null,
                queja_reclamo: textComplaint,
                fecha_respuesta: null,
                respuesta_requerimiento: null,
                medio: meanComplaint,
                seguimiento: tracing,
                canal_recepcion: receptionChanel,
                id_usuario: JSON.parse(sessionStorage.getItem('usuario')).id_usuario,
                prioridad: priority,
                asunto: dataAffairs.find(dat => dat.id_queja_asunto == subject).queja_asunto,
                id_queja_asunto: subject,
                respuesta_requerimiento: answerText,
                fecha_respuesta: answerDate != null && answerDate != null ? moment(answerDate).format("YYYY-MM-DD HH:mm:ss") : null
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                configAlertModal("success", "Queja Actualizada con Exito", 3, true);
            }
            else {
                throw new Error('Ha ocurrido un error creando la Queja');
            }
        }).catch(err => {
            configAlertModal("danger", "Ha ocurrido un error actualizando la Queja", null, true);
            console.log(err);
        });
    }

    const newComplaintsAndClaims = () => {
        if (!validateAdd()) {
            configAlertModal('warning', 'Esta seguro que desea crear la Queja y/o Reclamo con estos datos', 1, true);
        }
    }

    const editComplaintsAndClaims = () => {
        if (!validateAdd()) {
            configAlertModal('warning', 'Esta seguro que desea editar la Queja y/o Reclamo con estos datos', 2, true);
        }
    }

    const validateAdd = () => {
        let errors = {};
        let error = false;

        if (namePatient == null || namePatient == undefined || namePatient == "") {
            errors.namePatient = "El Nombre del Paciente es Obligatorio";
            error = true;
        }

        if (firstLastName == null || firstLastName == undefined || firstLastName == "") {
            errors.firstLastName = "El Primer Apellido del Paciente es Obligatorio";
            error = true;
        }

        if (numberDocument == null || numberDocument == undefined || numberDocument == "") {
            errors.numberDocument = "El número de Documento es Obligatorio";
            error = true;
        }

        if (typeDocument == null || typeDocument == undefined || typeDocument == "") {
            errors.typeDocument = "El tipo de Documento es Obligatorio";
            error = true;
        }

        if (meanComplaint == null || meanComplaint == undefined || meanComplaint == "") {
            errors.meanComplaint = "El medio por donde se realizo la Queja es Obligatoria";
            error = true;
        }

        if (tracing == null || tracing == undefined || tracing == "") {
            errors.tracing = "El seguimiento es Obligatorio";
            error = true;
        }

        if (priority == null || priority == undefined || priority == "") {
            errors.priority = "La prioridad es Obligatoria";
            error = true;
        }

        if (subject == null || subject == undefined || subject == "") {
            errors.subject = "El asunto es Obligatorio";
            error = true;
        }

        if (textComplaint == null || textComplaint == undefined || textComplaint == "") {
            errors.textComplaint = "La descripción de la Queja es Obligatoria";
            error = true;
        }

        setErrors(errors);
        return error;
    }

    const configAlertModal = (color, message, option, show) => {
        setColorAlertModal(color);
        setMessageAlertModal(message);
        setOptionAlertModal(option);
        setShowAlertModal(show);
    }

    const onOkModal = () => {
        switch (optionAlertModal) {
            case 1: //Creacion
                addComplaintsAndClaimsSubmit();
                break;
            case 2://Edition
                updateComplaintsAndClaimsSubmit();
                break;
            case 3: //Finalizar
                configAlertModal("", "", null, false);
                toBack();
                break;
            default:
                configAlertModal("", "", null, false);
                break;
        }
    }

    const onToggleModal = () => {
        switch (optionAlertModal) {
            case 3: //Finalizar
                configAlertModal("", "", null, false);
                toBack();
                break;
            default:
                configAlertModal("", "", null, false);
                break;
        }


        configAlertModal("", "", null, false);
    }

    const addAffairComplaint = () => {
        setOpenModalAffair(true);
    }

    const getAffairs = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'quejas-reclamos-asunto/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(data => {
            setDataAffairs(data);
        }).catch((error) => {
            setDataAffairs([]);
            console.error('Error:', error);
        });
    }

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <Tooltip title="Regresar a Lista de Quejas y Reclamos">
                        <Button className="btn btn-primary text-white btn-sm" onClick={() => toBack()}>
                            <FontAwesomeIcon className="text-white" icon={faArrowLeft} />
                        </Button>
                    </Tooltip>
                    <h3 style={{ marginBottom: 15 }}>{props.location.state.complaints_claim != null && props.location.state.complaints_claim != undefined ? <label>Actualizar Queja y/o Reclamo</label> : <label>Agregar Queja y/o Reclamo</label>}</h3>
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <div style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }} >
                        <Container className="container-fluid">
                            <b style={{ margin: 2 }}> Datos Basicos del Paciente</b>
                            <br /><br />
                            <Row>
                                <Col md={4}>
                                    <TextField
                                        className="medical-material-form__field"
                                        label="Tipo de Documento"
                                        id="type-documentn"
                                        style={{ width: '100%' }}
                                        select
                                        disabled={disabledFields}
                                        value={typeDocument}
                                        onChange={(event) => {
                                            setTypeDocument(event.target.value);
                                        }}
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink: typeDocument != null && typeDocument != undefined && typeDocument != "" ? true : false
                                        }}
                                        error={errors.hasOwnProperty("typeDocument") ? errors.typeDocument !== "" : false}
                                        helperText={errors.typeDocument}
                                    >
                                        <MenuItem key={0} value={"CC"}>CEDULA DE CIUDADANIA</MenuItem>
                                        <MenuItem key={1} value={"CE"}>CEDULA DE EXTRANJERIA</MenuItem>
                                        <MenuItem key={2} value={"PA"}>PASAPORTE</MenuItem>
                                        <MenuItem key={3} value={"CD"}>CARNET DIPLOMATICO</MenuItem>
                                        <MenuItem key={4} value={"SC"}>SALVO CONDUCTO</MenuItem>
                                    </TextField>
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        style={{ width: '100%' }}
                                        className="medical-material-form__field"
                                        id="number-document"
                                        label="Número de Documento"
                                        type="text"
                                        disabled={disabledFields}
                                        value={numberDocument}
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink: numberDocument != null && numberDocument != undefined && numberDocument != "" ? true : false
                                        }}
                                        onChange={(e) => {
                                            setNumberDocument(e.target.value);
                                        }}
                                        onBlur={() => {
                                            loadPatientInfo();
                                        }}
                                        error={errors.hasOwnProperty("numberDocument") ? errors.numberDocument !== "" : false}
                                        helperText={errors.numberDocument}
                                    />
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        style={{ width: '100%' }}
                                        className="medical-material-form__field"
                                        id="name-patient"
                                        label="Nombres"
                                        disabled={disabledFields}
                                        type="text"
                                        value={namePatient}
                                        onChange={(e) => {
                                            setNamePatient(e.target.value);
                                        }}
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink: namePatient != null && namePatient != undefined && namePatient != "" ? true : false
                                        }}
                                        error={errors.hasOwnProperty("namePatient") ? errors.namePatient !== "" : false}
                                        helperText={errors.namePatient}
                                    />
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        style={{ width: '100%' }}
                                        className="medical-material-form__field"
                                        id="first-last-name-patient"
                                        label="Primer Apellido"
                                        disabled={disabledFields}
                                        type="text"
                                        value={firstLastName}
                                        onChange={(e) => {
                                            setFirstLastName(e.target.value);
                                        }}
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink: firstLastName != null && firstLastName != undefined && firstLastName != "" ? true : false
                                        }}
                                        error={errors.hasOwnProperty("firstLastName") ? errors.firstLastName !== "" : false}
                                        helperText={errors.firstLastName}
                                    />
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        style={{ width: '100%' }}
                                        className="medical-material-form__field"
                                        id="second-last-name-patient"
                                        label="Segundo Apellido"
                                        disabled={disabledFields}
                                        type="text"
                                        value={secondLastName}
                                        onChange={(e) => {
                                            setSecondLastName(e.target.value);
                                        }}
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink: secondLastName != null && secondLastName != undefined && secondLastName != "" ? true : false
                                        }}
                                        error={errors.hasOwnProperty("secondLastName") ? errors.secondLastName !== "" : false}
                                        helperText={errors.secondLastName}
                                    />
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        style={{ width: '100%' }}
                                        className="medical-material-form__field"
                                        id="email-patient"
                                        label="Correo"
                                        disabled={disabledFields}
                                        type="email"
                                        value={emailPatient}
                                        onChange={(e) => {
                                            setEmailPatient(e.target.value);
                                        }}
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink: emailPatient != null && emailPatient != undefined && emailPatient != "" ? true : false
                                        }}
                                        error={errors.hasOwnProperty("emailPatient") ? errors.emailPatient !== "" : false}
                                        helperText={errors.emailPatient}
                                    />
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        style={{ width: '100%' }}
                                        className="medical-material-form__field"
                                        id="phone-patient"
                                        label="Telefono"
                                        disabled={disabledFields}
                                        type="text"
                                        value={phonePatient}
                                        onChange={(e) => {
                                            setPhonePatient(e.target.value);
                                        }}
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink: phonePatient != null && phonePatient != undefined && phonePatient != "" ? true : false
                                        }}
                                        error={errors.hasOwnProperty("phonePatient") ? errors.phonePatient !== "" : false}
                                        helperText={errors.phonePatient}
                                    />
                                </Col>
                            </Row>
                            <br />
                        </Container>
                    </div>

                    <div style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }} >
                        <Container className="container-fluid">
                            <b style={{ margin: 2 }}>Datos de la Queja y/o Reclamo</b>
                            <br /><br />
                            <Row>
                                <Col md={4}>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <ThemeProvider theme={defaultMaterialTheme}>
                                            <DatePicker
                                                disableFuture
                                                openTo="date"
                                                label="Fecha de Radicado"
                                                disabled={disabledFields}
                                                variant="inline"
                                                views={["year", "month", "date"]}
                                                value={claimDate}
                                                autoOk={true}
                                                onChange={(date) => {
                                                    setClaimDate(date);
                                                }}
                                                className='medical-material-form__field'
                                                animateYearScrolling
                                                format="yyyy/MM/D"
                                            />
                                        </ThemeProvider>
                                    </MuiPickersUtilsProvider>
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        className="medical-material-form__field"
                                        label="Medio"
                                        id="phone-number"
                                        style={{ width: '100%' }}
                                        select
                                        value={meanComplaint}
                                        onChange={(event) => {
                                            setMeanComplaint(event.target.value);
                                        }}
                                        error={errors.hasOwnProperty("meanComplaint") ? errors.meanComplaint !== "" : false}
                                        helperText={errors.meanComplaint}
                                        InputLabelProps={{
                                            style: { color: '#646777' },
                                            shrink: meanComplaint != null && meanComplaint != undefined && meanComplaint != "" ? true : false
                                        }}
                                    >
                                        <MenuItem key={0} value={"VIA TELEFONICA"}>VIA TELEFONICA</MenuItem>
                                        <MenuItem key={1} value={"EMAIL"}>EMAIL</MenuItem>
                                        <MenuItem key={2} value={"RECEPCION"}>RECEPCIÓN</MenuItem>
                                    </TextField>
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        className="medical-material-form__field"
                                        label="Seguimiento"
                                        id="tracing"
                                        style={{ width: '100%' }}
                                        select
                                        value={tracing}
                                        onChange={(event) => {
                                            setTracing(event.target.value);
                                        }}
                                        error={errors.hasOwnProperty("tracing") ? errors.tracing !== "" : false}
                                        helperText={errors.tracing}
                                    >
                                        <MenuItem key={0} value={1}>ABIERTA</MenuItem>
                                        <MenuItem key={1} value={2}>CERRADA</MenuItem>
                                        <MenuItem key={2} value={3}>PENDIENTE</MenuItem>
                                    </TextField>
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        className="medical-material-form__field"
                                        label="Canal de Recepcion"
                                        id="tracing"
                                        style={{ width: '100%' }}
                                        type="text"
                                        value={receptionChanel}
                                        onChange={(event) => {
                                            setReceptionChanel(event.target.value);
                                        }}
                                        error={errors.hasOwnProperty("receptionChanel") ? errors.receptionChanel !== "" : false}
                                        helperText={errors.receptionChanel}
                                    />
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        className="medical-material-form__field"
                                        label="Prioridad"
                                        id="priority"
                                        style={{ width: '100%' }}
                                        select
                                        value={priority}
                                        onChange={(event) => {
                                            setPriority(event.target.value);
                                        }}
                                        error={errors.hasOwnProperty("priority") ? errors.priority !== "" : false}
                                        helperText={errors.priority}
                                    >
                                        <MenuItem key={0} value={1}>BAJA</MenuItem>
                                        <MenuItem key={1} value={2}>MEDIA</MenuItem>
                                        <MenuItem key={2} value={3}>ALTA</MenuItem>
                                    </TextField>
                                </Col>
                                <Col md={4}>
                                    <Row>
                                        {/*
                                        <Col md={10}>
                                            <TextField
                                                className="medical-material-form__field"
                                                label="Asunto"
                                                id="subject"
                                                style={{ width: '100%' }}
                                                value={subject}
                                                onChange={(event) => {
                                                    setSubject(event.target.value);
                                                }}
                                                error={errors.hasOwnProperty("subject") ? errors.subject !== "" : false}
                                                helperText={errors.subject}
                                            />
                                        </Col>*/}

                                        <Col md={10}>
                                            <TextField
                                                className="medical-material-form__field"
                                                label="Asunto"
                                                id="subject"
                                                style={{ width: '100%' }}
                                                select
                                                value={subject}
                                                onChange={(event) => {
                                                    setSubject(event.target.value);
                                                }}
                                                error={errors.hasOwnProperty("subject") ? errors.subject !== "" : false}
                                                helperText={errors.subject}
                                                InputLabelProps={{
                                                    style: { color: '#646777' },
                                                    shrink: subject != null && subject != undefined && subject != "" ? true : false
                                                }}
                                            >
                                                {dataAffairs.map((dataAffair) => {
                                                    return <MenuItem key={dataAffair.id_queja_asunto} value={dataAffair.id_queja_asunto}>
                                                        {dataAffair.queja_asunto}
                                                    </MenuItem>
                                                })}
                                            </TextField>
                                        </Col>

                                        <Col md={2}>
                                            <br />
                                            <Tooltip title="Agregar Asunto">
                                                <IconButton aria-label="upload picture" component="span"
                                                    onClick={() => {
                                                        addAffairComplaint();
                                                    }}>
                                                    <FontAwesomeIcon icon={faPlus} />
                                                </IconButton>
                                            </Tooltip>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <ModalAffairComplaint opened={openModalAffair} closeModal={() => setOpenModalAffair(false)} affairsData={dataAffairs} Callback={() => getAffairs()} />

                            <Row>
                                <Col md={12}>
                                    <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                                        <div className="form__form-group" style={{ margin: 10 }}>
                                            <span className="form__form-group-label">Descripción de la Queja y/o Reclamo</span>
                                            <div className="form__form-group-field">
                                                <textarea
                                                    name="textarea-claim"
                                                    value={textComplaint}
                                                    onChange={(e) => { setTextComplaint(e.target.value) }}
                                                >
                                                </textarea>
                                            </div>
                                        </div>
                                        {errors.hasOwnProperty("textComplaint") ? <b className="text-danger">{errors.textComplaint}</b> : null}
                                    </div>
                                </Col>
                            </Row>
                            <br />
                        </Container>
                    </div>

                    {props.location.state.complaints_claim != null && props.location.state.complaints_claim != undefined ? <div style={{ border: '1px solid #B2B8BF', marginTop: 5, borderRadius: 5 }} >
                        <Container className="container-fluid">
                            <b style={{ margin: 2 }}>Datos de la Respuesta</b>
                            <br /><br />
                            <Row>
                                <Col md={4}>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <ThemeProvider theme={defaultMaterialTheme}>
                                            <DatePicker
                                                disableFuture
                                                openTo="date"
                                                label="Fecha de Respuesta"
                                                variant="inline"
                                                views={["year", "month", "date"]}
                                                value={answerDate}
                                                autoOk={true}
                                                disabled={disabledAnswer}
                                                onChange={(date) => {
                                                    setAnswerDate(date);
                                                }}
                                                className='medical-material-form__field'
                                                animateYearScrolling
                                                format="yyyy/MM/D"
                                            />
                                        </ThemeProvider>
                                    </MuiPickersUtilsProvider>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                                        <div className="form__form-group" style={{ margin: 10 }}>
                                            <span className="form__form-group-label">Respuesta a la Queja y/o Reclamo</span>
                                            <div className="form__form-group-field">
                                                <textarea
                                                    disabled={disabledAnswer}
                                                    name="textarea-claim-answer"
                                                    value={answerText}
                                                    onChange={(e) => { setAnswerText(e.target.value) }}
                                                >
                                                </textarea>
                                            </div>
                                        </div>
                                        {errors.hasOwnProperty("answerText") ? <b className="text-danger">{errors.answerText}</b> : null}
                                    </div>
                                </Col>
                            </Row>
                            <br />
                        </Container>
                    </div> : null}

                    <div>
                        <Row>
                            <Col md={12}>
                                <br />
                                {
                                    props.location.state.complaints_claim != null && props.location.state.complaints_claim != undefined ?
                                        <Button className="btn btn-primary text-white"
                                            onClick={() => {
                                                editComplaintsAndClaims();
                                            }}
                                        >
                                            Actualizar
                                        </Button> : <Button className="btn btn-primary text-white" onClick={() => newComplaintsAndClaims()}>
                                            Agregar
                                        </Button>
                                }
                            </Col>
                        </Row>
                    </div>
                </CardBody>
            </Card>

            <AlertModal
                color={colorAlertModal}
                title={messageAlertModal}
                modal={showAlertModal}
                onOk={() => {
                    onOkModal();
                }}
                toggle={() => {
                    onToggleModal();
                }}
            />

        </Container>
    )
}

export default FormComplaintsAndClaims;